import React, { Component } from "react";

import { bool, shape } from "prop-types";
import GridTable from "pages/_components/GridTable/GridTable";
import CustomText from "pages/_components/CustomText/CustomText";
import FormattedDate from "pages/_components/FormattedDate";
import FormattedAmount from "pages/_components/FormattedAmount";
import FormmatedText from "pages/_components/CustomText/_components/FormmatedText";
import { isIOS, isMobile } from "react-device-detect";
import { addUtcOffset } from "util/date";

class AgreementItem extends Component {
    static propTypes = {
        isDesktop: bool.isRequired,
        agreement: shape({}).isRequired,
    };

    render() {
        const { isDesktop, agreement } = this.props;
        const { agreementNumber, creationDate, expirationDate, tax, amount, currency } = agreement;
        return (
            <>
                {isIOS || isMobile ? (
                    <>
                        <GridTable.Data columnStart={1} rowStart={1}>
                            <CustomText text="tableHeader.number" textType="I18N" />
                        </GridTable.Data>
                        <GridTable.Data className="font-weight-500" columnStart={1} rowStart={2}>
                            <CustomText text={agreementNumber} textType="STRING" keepSpaceIfNoText />
                        </GridTable.Data>
                        <GridTable.Data className="mt-3" columnStart={1} rowStart={3}>
                            <CustomText text="tableHeader.expiracyDate" textType="I18N" />
                        </GridTable.Data>
                        <GridTable.Data
                            className="font-weight-500"
                            columnStart={isDesktop ? 3 : 1}
                            rowStart={isDesktop ? 1 : 4}>
                            <FormattedDate date={addUtcOffset(expirationDate)} dateFormat="DD/MM/YYYY" />
                        </GridTable.Data>
                        <GridTable.Data className="mt-3" columnStart={1} rowStart={5}>
                            <CustomText text="tableHeader.agreement" textType="I18N" />
                        </GridTable.Data>
                        <GridTable.Data
                            className="font-weight-500"
                            columnStart={isDesktop ? 5 : 1}
                            rowStart={isDesktop ? 1 : 6}
                            alignX={isDesktop ? "right" : "left"}>
                            <FormattedAmount currency={currency} quantity={amount} />
                        </GridTable.Data>
                        <GridTable.Data className="mt-3" columnStart={1} rowStart={7}>
                            <CustomText text="tableHeader.creationDate" textType="I18N" />
                        </GridTable.Data>
                        <GridTable.Data
                            className="font-weight-500"
                            columnStart={isDesktop ? 2 : 1}
                            rowStart={isDesktop ? 1 : 8}>
                            <FormattedDate date={addUtcOffset(creationDate)} dateFormat="DD/MM/YYYY" />
                        </GridTable.Data>
                        <GridTable.Data className="mt-3" columnStart={1} rowStart={9}>
                            <CustomText text="tableHeader.tna" textType="I18N" />
                        </GridTable.Data>
                        <GridTable.Data
                            className="font-weight-500"
                            columnStart={isDesktop ? 4 : 1}
                            rowStart={isDesktop ? 1 : 10}>
                            <FormmatedText text={tax} textType="PERCENTAGE" />
                        </GridTable.Data>
                    </>
                ) : (
                    <>
                        <GridTable.Data columnStart={1} rowStart={1}>
                            <CustomText text={agreementNumber} textType="STRING" keepSpaceIfNoText />
                        </GridTable.Data>
                        <GridTable.Data columnStart={2} rowStart={1}>
                            <FormattedDate date={addUtcOffset(creationDate)} dateFormat="DD/MM/YYYY" />
                        </GridTable.Data>
                        <GridTable.Data columnStart={isDesktop ? 3 : 1} rowStart={isDesktop ? 1 : 2}>
                            <FormattedDate date={addUtcOffset(expirationDate)} dateFormat="DD/MM/YYYY" />
                        </GridTable.Data>
                        <GridTable.Data columnStart={isDesktop ? 4 : 2} rowStart={isDesktop ? 1 : 2}>
                            <FormmatedText text={tax} textType="PERCENTAGE" />
                        </GridTable.Data>
                        <GridTable.Data
                            columnStart={isDesktop ? 5 : 1}
                            rowStart={isDesktop ? 1 : 3}
                            alignX={isDesktop ? "right" : "left"}>
                            <FormattedAmount currency={currency} quantity={amount} />
                        </GridTable.Data>
                    </>
                )}
            </>
        );
    }
}

export default AgreementItem;
